import * as React from "react";
import { Outlet } from "react-router";

import { SiteHeader } from "@/components/layouts/site-header";
import { AppSidebar } from "@/components/navigation/app-sidebar";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { DistrictProvider } from "@/contexts/district-context";
import { ResellerProvider } from "@/contexts/reseller-context";
import { useBranding } from "@/hooks/use-branding";

export function ProtectedLayout() {
	useBranding();

	return (
		<DistrictProvider>
			<ResellerProvider>
				<SidebarProvider
					className="h-svh"
					style={
						{
							"--sidebar-width": "calc(var(--spacing) * 56)",
							"--header-height": "calc(var(--spacing) * 12)",
						} as React.CSSProperties
					}
				>
					<AppSidebar variant="inset" />
					<SidebarInset className="overflow-hidden">
						<SiteHeader />
						<main
							id="main-content"
							tabIndex={-1}
							className="flex min-h-0 flex-1 flex-col"
						>
							<ErrorBoundary>
								<Outlet />
							</ErrorBoundary>
						</main>
					</SidebarInset>
				</SidebarProvider>
			</ResellerProvider>
		</DistrictProvider>
	);
}
